// extracted by mini-css-extract-plugin
export default {"noWrap":"aSh0Jc","ctaLink":"oAnDc7"};